import {Box,Flex,Text,Image,Avatar,Badge,Divider, Tooltip} from "@chakra-ui/react";
import MyDiv from "./attendanceListCard.style";
import Arrow from "../../../../assets/images/ArrowHistory.svg";
import BackgroundProfileImg from "../../../../assets/images/CardBackgroundImg.jpg";
import DepartmentFrame from "../../../../assets/images/DepartmentFrame.svg"
import BranchFrame from "../../../../assets/images/BranchFrame.svg";
import EmailFrame from "../../../../assets/images/EmailFrame.svg";
import PhoneFrame from "../../../../assets/images/PhoneFrame.svg";
import DummyPerson from "../../../../assets/images/DummyPerson.svg"
import CopyIcon from "../../../../assets/images/CopyIcon.svg"
import { useNavigate } from "react-router-dom";
import * as routesNames from '../../../../constants/routes'
import { useState } from "react";
import { CustomToast } from '../../../../components';
import { baseUrl, useFetch } from '../../../../hooks/useFetch';
import {useEffect} from "react";
import { ProfileDetail,Props } from "./model";
import { useAuth } from "../../../../hooks/useAuth";

const AttendanceListCard = ({ employeeId, date }: Props) => {
  const { addToast } = CustomToast();
  const { fetchApi } = useFetch(addToast);
  const navigate = useNavigate();
  const { loginObj } = useAuth();
  const [avatarUrl, setAvatarUrl] = useState<string | null>(null);
  const [employee, setEmployee] = useState<ProfileDetail | null>(null);
  const [attendanceData, setAttendanceData] = useState<any>(null);
  
  useEffect(() => {
    if (!employeeId) return;

    const fetchAvatar = async () => {
      try {
        const res = await fetch(`${baseUrl}Hrlense_Employee/profilepic/${employeeId}`, {
          method: "GET",
          headers: {
            Authorization: `Bearer ${loginObj?.token || ""}`,
          },
        });

        if (!res.ok) throw new Error("Avatar not found");

        const blob = await res.blob();
        if (blob.size > 0) {
          setAvatarUrl(URL.createObjectURL(blob));
        } else {
          setAvatarUrl(null);
        }
      } catch (err) {
        console.error("Error fetching avatar", err);
        setAvatarUrl(null); 
      }
    };

    fetchAvatar();
  }, [employeeId]);


   async function profileDetail() {
    const response = await fetchApi('Hrlense_Employee/profileCard', "GET", null, `employeeId=${employeeId}`, "");
    if (response) {
      setEmployee(response);
    }
  }

   const handleClick = () =>{
    navigate(routesNames.ATTENDANCEDETAIL, { state: { employeeId: employeeId,date: date } });
  }

  useEffect(() => {
    if (employeeId) {
      profileDetail();
      LoadAttendanceData();
    }
  }, [employeeId]);


  const LoadAttendanceData = async () => {
    try {
         const params = new URLSearchParams({
            employeeId: employeeId ? employeeId.toString() : "",  // 👈 pass employeeId
            month: (date.getMonth() + 1).toString(),
            year: date.getFullYear().toString(),
        });
        const response = await fetchApi(
            `Hrlense_Attendance/GetEmployeeMonthlyAttendanceByEmployee?${params}`,
            "GET"
        );
        if (response) {
            if (response.records.length === 0) {
                addToast({
                    message: "No attendance data found for the selected month.",
                    status: "warning",
                });
            }
            setAttendanceData(response);
        }
    } catch (error) {
        console.error("Error fetching attendance data:", error);
    }
};

const copyToClipboard = (text: string, type: string) => {
    navigator.clipboard.writeText(text);
    addToast({ message: `${type} copied!`, status: 'success' });
  }
  return (
    <MyDiv>
      <Box className="card_wrapper">
        <Box position="relative" h="140px" >
          <Image src={BackgroundProfileImg} alt="Cover" w="100%" h="100%" objectFit="cover" />
        </Box>
        <Flex align="center" gap={4} px={5} mt={-10}>
        <Avatar src={avatarUrl ? avatarUrl : DummyPerson} name="" size="xl"/>
          <Box w="100%" mt={12}>
            <Flex justifyContent="space-between" alignItems="center" width="100%">
              <Tooltip label={employee?.name} placement="top" hasArrow>
            <Text className="font-poppins text_xl text_medium font_dark" maxWidth="11vw" isTruncated>
                {employee?.name}
              </Text>
              </Tooltip>
              <Text className="font-poppins text_sm text_medium "color={employee?.status === "Active" ? "#38A169" : "#E53E3E"}>
                {employee?.status}
              </Text>
            </Flex>

            <Flex gap={3} mt={2} alignItems="center" flexWrap="wrap">
              <Badge className="badgeId font-poppins text_medium">
                {employee?.empCode}
                <Image src={CopyIcon} alt="Copy" cursor="pointer" 
                 onClick={(e) => {
                   e.stopPropagation();
                   copyToClipboard(employee?.empCode ?? "", "Employee ID"); 
                 }}
                />
              </Badge>
              <Tooltip label={employee?.designation} placement="top" hasArrow>
              <Badge className="badgeDegi font-poppins text_sm text_medium" maxWidth="9vw" isTruncated> {employee?.designation}</Badge>
              </Tooltip>
            </Flex>
          </Box>
        </Flex>
        <Divider orientation="horizontal" mt={2} />
        <Box px={4} mt={4}>
          <Text className="font-poppins font_dark text_medium text_sm" mb="8px">Basic Information</Text>
          <Flex className="info_grid">
            <Flex align="center" gap={2}>
              <Image src={DepartmentFrame} />
              <Flex flexDirection="column">
                <Text className="font-poppins text_medium" fontSize="8px" color="rgba(0, 0, 0, 0.5)">Department</Text>
                <Text className="font-poppins font_dark text_medium text_sm">{employee?.department}</Text>
              </Flex>
            </Flex>
            <Flex align="center" gap={2}>
              <Image src={BranchFrame} />
              <Flex flexDirection="column">
                <Text className="font-poppins  text_medium" fontSize="8px" color="rgba(0, 0, 0, 0.5)">Branch</Text>
                <Text className="font-poppins font_dark text_medium text_sm">{employee?.branch}</Text>
              </Flex>
            </Flex>
            <Flex align="center" gap={2}>
              <Image src={EmailFrame} />
              <Flex flexDirection="column">
                <Text className="font-poppins  text_medium" fontSize="8px" color="rgba(0, 0, 0, 0.5)">Email</Text>
                <Tooltip label={employee?.email} placement="top" hasArrow>
                <Text className="font-poppins font_dark text_medium text_sm"maxWidth="8vw" isTruncated>{employee?.email}</Text>
                </Tooltip>
              </Flex>
            </Flex>
            <Flex align="center" gap={2}>
              <Image src={PhoneFrame} />
              <Flex flexDirection="column">
                <Text className="font-poppins  text_medium" fontSize="8px" color="rgba(0, 0, 0, 0.5)">Phone</Text>
                <Text className="font-poppins font_dark text_medium text_sm">{employee?.phone}</Text>
              </Flex>
            </Flex>
          </Flex>
        </Box>
        <Divider orientation="horizontal" mt={4} />
        <Box px={4} mt={2}>
          <Text className="font-poppins font_dark text_medium text_sm">Attendance Overview</Text>
          <Box className="overview_card green">
            <Text className="font-poppins font_dark text_medium text_sm">Presence</Text>
            <Text className="font-poppins text_medium text_3xl" color="#008000">   {attendanceData ? `${attendanceData.presencePercent}%` : "0%"}</Text>
          </Box>
          <Box className="overview_card orange">
            <Text className="font-poppins font_dark text_medium text_sm">Leave & Other</Text>
            <Text className="font-poppins text_medium text_3xl" color="#FFA500"> {attendanceData ? `${attendanceData.leaveOrOtherPercent}%` : "0%"}</Text>
          </Box>
        </Box>
        <Box  m={4} className="history_btn">
          <Flex justifyContent="space-between" alignItems="center" onClick={handleClick} cursor="pointer">
             <Text className="font-poppins font_dark text_medium text_sm">Attendance History</Text>
             <Image src={Arrow} alt="History"  />
          </Flex>
        </Box>
      </Box>
    </MyDiv>
  );
};

export default AttendanceListCard;
